/**
 * The 3rd and 4th arguments ensure that this module is executed synchronously, to register
 * the InsertFiles plugin before AJS.Rte.BootstrapManager.initialise is executed.
 *
 * This is necessary at the moment because we're still in the process of switching over to using
 * AMD throughout the codebase, and don't yet have a holistic approach to ensuring that all
 * TinyMCE plugins are registered before AJS.Rte.BootstrapManager.initialise is called.
 * @tainted tinymce
 */

import window from 'window-or-global';

// Stylesheet.
require('./insert-files.css');

const insertFilesPlugin = function () {
	return {
		init(ed) {
			//add a button in toolbar
			ed.addButton('confluence-insert-files', {
				//default value of "toolbar" is "toolbar-primary"
				title: ed.translate('tinymce.confluence.files'),
				tooltip: `${ed.translate(
					'tinymce.confluence.conf_file_desc',
				)} (${ed.translate('tinymce.confluence.conf_file_shortcut')})`,
				cmd: 'mceConfimage',
				className: 'insert-files',
				icon: 'aui-icon aui-icon-small aui-iconfont-editor-files',
				locationGroup: 'rte-toolbar-group-files',
				weight: 0, //order of the new button in group, 0 => insert at beginning
			});
		},

		getInfo() {
			return {
				longname: 'Insert Files',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				infourl: 'http://www.atlassian.com/',
				version: '1.0',
			};
		},
	};
};

export default function () {
	window.tinymce.create('tinymce.plugins.InsertFiles', insertFilesPlugin());
	window.tinymce.PluginManager.add('insertfiles', window.tinymce.plugins.InsertFiles);
}
